import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("获取")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回")

import PptEditor from '@/components/ppt-editor/PptEditor.vue'
import { createVNode, onMounted, ref } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { eventCenter, event } from '@evideo/frontend-utils'
import config from '@/config'
import { addInstitutionDownloadLog, copyInstitutionShareCourseware, getInstitutionCoursewareInfo } from '../service'
import { message, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { shareModeEnum } from '@/utils/dataMap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onBeforeRouteLeave((to, from, next) => {
  eventCenter.send(event.COMMON_UNLOAD_MICRO_APP, {
    app: config.pptist.name
  })
  setTimeout(() => {
    next()
  }, 0)
})

const route = useRoute()
const router = useRouter()
const id: string = (route.params.id as string)

const fileName = ref<string>('')

const fileInfo = ref<any>()

const canCopy = ref<boolean>()

const loading = ref<boolean>()

const url = ref<string>()

const pptEditor = ref()

const formData = ref('teacher')
const courseData = ref('')

// 本地增加下载量
const handleUpdateDownloadNum = () => {
  if (fileInfo.value.popularity) {
    if (fileInfo.value.popularity?.download_num) {
      fileInfo.value.popularity.download_num++
    } else {
      fileInfo.value.popularity.download_num = 1
    }
  } else {
    fileInfo.value.popularity = {
      download_num: 1
    }
  }
}

const handleCopy = async () => {
  try {
    loading.value = true
    const params = { area_public_courseware_id: id }
    addInstitutionDownloadLog(id)
    await copyInstitutionShareCourseware(params)
    message.success('添加到我的课件成功')
    handleUpdateDownloadNum()
    loading.value = false
  } catch (error) {
    console.log(error)
    message.error('添加到我的课件失败，请重试')
    loading.value = false
  }
}

const handleGoBack = () => {
  router.push('/resource/courseware-square')
}

const handleShowWarning = () => {
  Modal.confirm({
    title: '是否确认将课件添加到我的课件中',
    icon: createVNode(ExclamationCircleOutlined),
    closable: true,
    onOk: handleCopy,
    onCancel: () => {
      Modal.destroyAll()
    }
  })
}

onMounted(async () => {
  // addViewLog(id)
  const data = await getInstitutionCoursewareInfo(id)
  url.value = data.url
  fileName.value = data.name
  fileInfo.value = data
  console.log(data)
  courseData.value = data.author_courseware_id
  if (data.share_mode !== shareModeEnum.NOCOPY) {
    canCopy.value = true
  }
})


return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_page_header = _resolveComponent("a-page-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_page_header, {
      title: "预览课件",
      subTitle: fileName.value,
      style: {"background-color":"white"}
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            (canCopy.value)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: handleShowWarning,
                  style: _normalizeStyle({ disabled: loading.value }),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, { onClick: handleGoBack }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createElementVNode("span", null, "人气值：" + _toDisplayString(fileInfo.value?.popularity?.popularity || 0), 1),
            _createElementVNode("span", null, "下载量：" + _toDisplayString(fileInfo.value?.popularity?.download_num || 0), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["subTitle"]),
    (courseData.value)
      ? (_openBlock(), _createBlock(PptEditor, {
          key: 0,
          resource: url.value,
          ref: (_value, _refs) => {
            _refs['pptEditor'] = _value
            pptEditor.value = _value
          },
          type: "preview",
          width: "100%",
          height: "90vh",
          autoHideMenu: true,
          resourceType: "school"
        }, null, 8, ["resource"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})